import axiosInstance from "src/utils/axios";

// Reads whether the current user has joined the official WhatsApp group.
// This is the source of truth (backed by the users.whatsapp_group_joined
// column) — it must be checked on every login/app load rather than trusting
// localStorage alone, since localStorage is per-browser and gets cleared.
const getWhatsAppGroupJoinedStatus = async () => {
  const { status, data } = await axiosInstance.get(
    "api/user/whatsapp-group/joined"
  );
  return { status, data };
};

export default getWhatsAppGroupJoinedStatus;
